export default __webpack_public_path__ + "media/Agents_hero_tablet_mobile.9ca2ae09c3fea5a3501030173da56a71.svg";